/** Tipos del menú Ficha > Descargar información, en el formato legado de BDL. */
export const COMPANY_CONFIG_DOWNLOAD_TYPES: Record<number, string> = {
  1: 'Politicas',
  2: 'Campos Extras Gasto',
  3: 'Campos Extras Informe',
  4: 'Categorias e Impuestos',
  5: 'Configuración',
  6: 'Flujos de Revision',
  7: 'Opciones campos extras gastos',
  8: 'Opciones campos extras informes',
};

export function legacyCompanyConfigFilename(
  option: number,
  companyName: string,
  when: Date = new Date(),
  extension = 'xlsx',
): string {
  const tipo = COMPANY_CONFIG_DOWNLOAD_TYPES[option] ?? `Opcion ${option}`;
  const name = companyName.trim() || 'Sin nombre';
  const y = when.getFullYear();
  const m = String(when.getMonth() + 1).padStart(2, '0');
  const d = String(when.getDate()).padStart(2, '0');
  return `${tipo} Empresa ${name} - ${y}${m}${d}.${extension}`;
}

/**
 * Nombre de archivo de Content-Disposition.
 * Prefiere filename* (RFC 5987) y si no, filename.
 */
export function parseContentDispositionFilename(header: string | null | undefined): string | null {
  if (!header) {
    return null;
  }
  const encoded = /filename\*\s*=\s*(?:UTF-8''|utf-8'')?("[^"]+"|'[^']+'|[^;]+)/i.exec(header);
  if (encoded) {
    const raw = stripQuotes(encoded[1]);
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }
  const plain = /filename\s*=\s*("[^"]+"|'[^']+'|[^;]+)/i.exec(header);
  if (!plain) {
    return null;
  }
  const name = stripQuotes(plain[1]);
  return name || null;
}

export function extensionFromContentType(contentType: string | null | undefined): 'xlsx' | 'csv' | null {
  const value = (contentType ?? '').toLowerCase();
  if (value.includes('text/csv') || value.includes('application/csv')) {
    return 'csv';
  }
  if (
    value.includes('spreadsheetml') ||
    value.includes('application/vnd.ms-excel') ||
    value.includes('application/xlsx')
  ) {
    return 'xlsx';
  }
  return null;
}

export function resolveCompanyDownloadFilename(input: {
  contentDisposition: string | null;
  contentType: string | null;
  option: number;
  companyId: number;
  companyName?: string | null;
  now?: Date;
}): string {
  const extension = extensionFromContentType(input.contentType) ?? 'xlsx';
  const fromHeader = parseContentDispositionFilename(input.contentDisposition);
  if (fromHeader) {
    return applyExtension(fromHeader, extension);
  }
  return legacyCompanyConfigFilename(
    input.option,
    (input.companyName ?? '').trim(),
    input.now ?? new Date(),
    extension,
  );
}

function applyExtension(filename: string, extension: 'xlsx' | 'csv'): string {
  if (new RegExp(`\\.${extension}$`, 'i').test(filename)) {
    return filename;
  }
  if (/\.(xlsx|xls|csv)$/i.test(filename)) {
    return filename.replace(/\.(xlsx|xls|csv)$/i, `.${extension}`);
  }
  return `${filename}.${extension}`;
}

function stripQuotes(value: string): string {
  return value.trim().replace(/^["']|["']$/g, '').trim();
}
